// extracted by mini-css-extract-plugin
export default {"appleImageBox":"StoreButton-module__appleImageBox--ZVCYU","googleImageBox":"StoreButton-module__googleImageBox--AzswR"};